import React, { isValidElement, useCallback } from 'react';
import classnames from 'classnames';

import { isElementOfType } from '../../utilities/components';

import WpIcon from '../icon/WpIcon';

import './WpDropdownMenuItem.scss';

type Color = 'default' | 'danger';
const DEFAULT_COLOR = 'default';

export interface Props {
  children?: React.ReactNode;
  toggle?: Function;
  onClick?: Function;
  color?: Color;
  disabled?: boolean;
  isInDrawer?: boolean;
  qaTest?: string;
  closeOnClick?: boolean;
  removeBackgroundHover?: boolean;
  selected?: boolean;
  backgroundColor?: Color;
  width?: string;
}

const WpDropdownMenuItem = React.forwardRef(function WpDropdownMenuItem(
  {
    children,
    onClick,
    toggle,
    disabled = false,
    color = DEFAULT_COLOR,
    isInDrawer = false,
    qaTest,
    closeOnClick = true,
    removeBackgroundHover = false,
    selected = false,
  }: Props,
  ref: any
) {
  const classNamePrefix = 'WpDropdownMenuItem';

  const childrenLength = React.Children.count(children);

  const classes = classnames(
    classNamePrefix,
    `${classNamePrefix}--color-${color}`,
    selected && `${classNamePrefix}--selected`,
    disabled ? `${classNamePrefix}--disabled` : false,
    isInDrawer ? `${classNamePrefix}--drawer` : false,
    removeBackgroundHover ? `${classNamePrefix}--no-bg` : false
  );

  const handleClick = useCallback(() => {
    if (disabled) return;
    if (closeOnClick && toggle) toggle();
    if (onClick) onClick();
  }, [disabled, onClick]);

  return (
    <li data-test={qaTest} className={classes} onClick={handleClick} ref={ref}>
      {React.Children.map(children, (child: React.ReactElement<any>, index: number) => {
        if (child && isElementOfType(child, WpIcon)) {
          return (
            <span
              className={` ${
                childrenLength - 1 === index ? `${classNamePrefix}__icon--end` : `${classNamePrefix}__icon--start`
              } `}
            >
              {React.cloneElement(child, { size: child.props.size || 'sm' })}
            </span>
          );
        } else if (isValidElement(child)) {
          return React.cloneElement(child);
        }
        return child;
      })}
    </li>
  );
});

export default WpDropdownMenuItem;
